<template>
  <div class="PinsTableComponent DataTables">
    <p>{{ lang.infotext_1 }}:</p>
    <b-form-select v-if="libraryType == libraryTypes.HDLSYMBOL && symbolHDLListSelected.length > 0"
      id="initial-sort-select" v-model="symbolHDLListSelected[0]" :options="symbolHDLListOptions" size="sm"
      class="hdlsymbol-select"></b-form-select>
    <div v-show="isData" :id="id"></div>

    <LoaderComponent v-if="!isData"></LoaderComponent>

  </div>
</template>
<script>


import LoaderComponent from "@/components/shared/LoaderComponent";
import { mapGetters } from 'vuex'
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '@/Tools/Tools'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
  name: 'PinsTableComponent',
  props: {
    lang: Object,
    parent: String

  },
  components: {
    LoaderComponent

  },
  data() {
    return {
      name: 'PinsTableComponent',
      mainTable: "",
      id: "PinsTableComponent" + this._uid,
      columns: [],
      colsAssign: [],
      elements: [],
      isData: false,
      elementId: "",
      symbolHDLListOptions: [],
      symbolHDLListSelected: [],

      hdlEelements: [],
    }
  },
  computed: {
    ...mapGetters([
      'selectedRevisionRow',

    ]),
    libraryTypes() {
      return LibraryTypes;
    },
    revisionId() {

      if (this.parent == "bom") {
        return this.$store.getters.selectedPartBomRow.revisionId;
      }
      if (this.$route.path == "/LibraryManager/LibraryTable") {
        if (this.$store.getters.selectedRows[0] != undefined) {
          if (this.$store.getters.sectionPrefix == "pm") {

            this.elementId = this.$store.getters.selectedRows[0].col___revisionId.partId;
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            this.elementId = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
          }
          return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        }
      }
      if (this.$route.path == "/LibraryManager/LibraryDetails") {
        if (this.selectedRevisionRow[0] != undefined) {

          this.elementId = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
          return this.selectedRevisionRow[0].revisionId;
        }
        
      }
      return ""




    },
    libraryType() {
      if (this.parent == "bom") {
        return this.$store.getters.selectedPartBomRow.revisionId;
      }
      if (this.$store.getters.selectedRows[0] != undefined) {
        
        return this.$store.getters.selectedRows[0].col___libraryType.value.display;
      }
      return ""
    },

    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    }

  },
  created() {

    this.createTable();


  },
  watch: {
    revisionId: {
      handler: function () {

        this.createTable();
      },
      deep: true


    },


    reloadedAfterActionComplex: {
      handler: function (newValue) {
        
        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.createTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    symbolHDLListSelected: function (newVal) {
      
      if (newVal.length > 0) {
        this.elements = this.hdlEelements[newVal];

        this.buildTable();
      }

    }
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable() {
      this.isData = false;
      let vue = this;

      let prefix = this.$store.getters.sectionPrefix;
      if (this.parent == "bom") {
        prefix = "lm";
      }

      this.symbolHDLListSelected = [];
      this.symbolHDLListOptions = [];
      
      let obj = {

        revisionId: this.revisionId


      }
     

      this.$store.dispatch(prefix + "_getPins", obj)
        .then((result) => {
          console.log(result)
          if (result.status == "OK") {

            if (result.data.length > 0) {
              vue.elements = result.data[0].pins;

              if (vue.libraryType == LibraryTypes.HDLSYMBOL) {
                vue.symbolHDLListSelected.push(result.data[0].name);

                for (let i = 0, lei = result.data.length; i < lei; i++) {
                  vue.symbolHDLListOptions.push(result.data[i].name)

                  vue.elements = result.data;

                  vue.hdlEelements[result.data[i].name] = result.data[i].pins;
                }


              }
            }
            vue.isData = true;
            this.buildColumns();

          } else {
            vue.isData = false;
          }


        })
    },
    buildColumns() {

      
      if (this.libraryType == LibraryTypes.FOOTPRINT) {
        this.columns = [
          {
            name: "Id",
            alignInColumn: "left",
            type: "text"
          },
          {
            name: this.lang.table_header_Number,
            alignInColumn: "left",
            type: "text"
          },
          {
            name: this.lang.table_header_Padstack,
            alignInColumn: "left",
            type: "taxt"
          },
          {
            name: this.lang.table_header_Type,
            alignInColumn: "left",
            type: "text"
          },


        ]

        this.colsAssign = [
          { "data": "padstackRevisionId" },
          { "data": "pinNumber" },
          { "data": "padstackName" },
          { "data": "type" },


        ]
      }
      if (this.libraryType == LibraryTypes.PART  || this.libraryType == LibraryTypes.HDLSYMBOL) {
        this.columns = [
          
          {
            name: this.lang.table_header_Number,
            alignInColumn: "left",
            type: "text"
          },
          {
            name: this.lang.table_header_Name,
            alignInColumn: "left",
            type: "text"
          },
          {
            name: this.lang.table_header_Type,
            alignInColumn: "left",
            type: "text"
          },
          


        ]
        this.colsAssign = [
          
          { "data": "pinNumber" },
          { "data": "pinName" },
          { "data": "type" },


        ]
      }

      

      this.buildTable();
    },
    buildTable() {

      var tableplace = document.getElementById(this.id);
      if (tableplace == null) {
        return;
      }

      while (tableplace.firstChild) {
        tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++) {

        var el = {};

        var classname = '_dt-body-' + this.columns[i].alignInColumn;

        el = {
          targets: i,
          className: classname,

          render: function (data, type, row, meta) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 4) {
              if (data == null) {
                return "";
              }
              let variant = Tools.getStatusColor(data);
              return "<b-badge class='badge badge-" + variant + " '>" + data + "</b-badge>";
            }


            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        //var p = document.createElement("p");
        //th.appendChild(p);
        var br = document.createElement("br");
        th.appendChild(br);
        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }
      
      let no = 0;
      if (this.libraryType == LibraryTypes.FOOTPRINT) {
        no = 1;
      }
      
      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fr<t>ip>';
      option.data = this.elements;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[no, "asc"]];
      option.lengthMenu = [[30]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {


        

      }



      if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
        this.mainTable.destroy();
        
      }

      var _vue = this;

      this.mainTable = $('#t_' + this.id).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      
      if (this.libraryType == LibraryTypes.FOOTPRINT) {
        this.mainTable.column(0).visible(false);
      }

      let _mainTable = this.mainTable;

      this.mainTable
        .on('select', function (e, dt, type, indexes) {

          var rowData = _mainTable.rows(indexes).data();





        })
        .on('deselect', function (e, dt, type, indexes) {


        })
      if (this.libraryType == LibraryTypes.FOOTPRINT) {



        $('#t_' + this.id + " tbody").on('dblclick', 'tr', function () {


          let rowData = _mainTable.rows(this._DT_RowIndex).data();

          _vue.goTo(rowData[0]);



        });
      }

      //search input change view
      var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:") {
          searchplace.removeChild(searchplace.firstChild);
          break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


    },
    goTo(goalObj) {

      
      
      let id = goalObj.padstackLibraryId;

      let to = "/LibraryManager/LibraryDetails";
        
      let  obj = {
          col___revisionId: {
            revisionId: goalObj.padstackRevisionId,
            libraryId: id,
            value: {
              display: goalObj.padstackRevisionId
            }
          },
          col___revision: {
            revisionId: goalObj.padstackRevisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.padstackRevisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.padstackRevisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.padstackRevisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.padstackRevisionId,
            libraryId: id,
            libraryType: LibraryTypes.PADSTACK,
            value: {
              display: LibraryTypes.PADSTACK
            }
          },

        }
      




      
      const goToObj = {
        to: {
          path: to,
          revisionId: goalObj.padstackRevisionId,
          id: goalObj.id
        },
        back: {
          path: this.$route.path,
          revisionId: this.revisionId,
          id: this.elementId
        },
        bom: {

        }
      }
      this.$store.dispatch("goTo", goToObj);



      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);




      const query = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.padstackRevisionId,
        id: id,
        sourceId: this.elementId,
        sourceRevisionId: this.revisionId,
        end: false
      }

      this.$router.push({ path: to, query: query });
    },

  }
}
</script>


<style lang="scss">
.PinsTableComponent {
  width: 100%;

  .dataTable {
    width: 100%;
  }

  table {
    font-size: 0.75rem;
    padding: 0px !important;

  }

  table th {
    padding: 2px !important;

  }

  table th select {
    width: 100% !important;

  }

  table td {
    padding: 0rem !important;

    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;

  }

  table.dataTable thead th {
    position: relative;
    background-image: none !important;
  }

  table.dataTable thead th p {
    margin-right: 20px;
  }

  .dataTables_processing {
    position: absolute;
    top: 20px;
    left: 50%;
    width: 100%;
    height: 20px;
    margin-left: -50%;
    margin-top: 50px;
    padding-top: 5px;
    text-align: center;
    font-size: 1em;

  }

  .dataTables_filter {
    font-size: 10px;
    float: left;
    width: 210px;
  }

  .searcher {
    float: left;
  }

  .dt-buttons {

    font-size: 0.7rem;
    margin-left: 210px;

  }

  .dataTables_filter .form-control-sm,
  .input-group-sm>.form-control {
    padding: 0.1rem 0.1rem;
    font-size: 0.7rem;
    line-height: 1;
    width: 200px;
  }

  .btn {
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 3px;
    padding-right: 3px;

    font-size: 0.7rem;

  }

  .btn-group {
    display: block;
    padding-top: 2px;
  }

  ._dt-body-left {
    text-align: left;
  }

  ._dt-body-right {
    text-align: right;
  }

  ._dt-body-center {
    text-align: center;
  }

  .image {
    max-width: 40px;
    border: solid 3px #666;
    border-radius: 2px;
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .imageSVG {
    max-width: 40px;
    border: solid 3px #666;
    border-radius: 2px;
    margin-top: 3px;
    margin-bottom: 3px;
    padding: 5px;
  }
  .custom-select-sm {
      height: calc(1em + 0.5rem + 2px);
      padding-top: 0.0rem;
      font-size: 0.75rem;
  }
  .hdlsymbol-select{
    float: right;
    width: 50%;
  }
}</style>



// WEBPACK FOOTER //
// src/components/shared/PinsTableComponent.vue